import React, { Component } from 'react'
import Slick from './reactSlick';
import "./style.less"
import _ from 'lodash';
import { DejaPrice } from 'src-features/commonUI/price'
import { Heart } from 'src-features/commonUI/arrow'
import {localStore} from 'src-common/utils';
import "react-image-gallery/styles/css/image-gallery.css"

const favorite = (id) => () => {
    let oldData = localStore.getStore('interact_data');
    oldData.interact_data.product_id_list.push(id);
    localStore.setStore('interact_data', oldData);
}
class ProductChoice extends Component {
    render() {
        const {action, status, choices, active} = this.props;
        return (
            <div className="product-interaction">
                <p className="status">{status}</p>
                <div className='btn-container'>
                {
                    choices.map(choice => (
                        <div type="button" key={choice.index} className={`div-btn ${active===choice.index ? 'active':''}`} onClick={action(choice.index)}>
                            {choice.choice}
                        </div>
                    ))
                }
                </div>
                
            </div>
        )
    }
}
class Product extends Component {
    state = {
        current: 0
    }
    changeSelect = (index) => {
        let self = this;
        return (e) => {
            e.preventDefault();
            if (index === self.state.current) return;
            self.setState({
                current: index
            })
        }
    }
    render() {
        const {shop_items = [], shop_url} = this.props;
        if(_.isNull(shop_items)) return <div style={{textAlign: 'center'}}><h2>Server data error</h2></div>
        const activeItem = shop_items.filter((item, index) => index===this.state.current);
        const activeImgs = activeItem.map(item => item.images);
        const currentItem = activeItem[0];
        const descriptionsMap = {
            description: 'Description',
            composition_and_care: 'Composition and Care',
            delivery_and_return_description: 'Delivery and Return'
        }
        const descriptions = ['description', 'composition_and_care', 'delivery_and_return_description']
        return (
            <div className="deja-product">
                    <div className="banner">
                        <div className="avatar">
                            <span style={{
                                fontSize: '16px',
                                color: '#000000',
                                fontWeight: 600,
                                letterSpacing: 0}}>Similar Items</span>
                        </div>
                        <div className="action"><Heart action={favorite(currentItem.shop_item_id)} color="#000000" size="26px"/></div>
                    </div>
                <div className='product-container'>
                    
                    <div className="product-react-slick">
                        <Slick imgs={activeImgs}/>
                    </div>
                    <div className="product-info-container">
                        <div className="product-info">
                            <h2 className="product-name">
                                {currentItem.shop_item_name}
                                <p className="brand">
                                    {currentItem.shop_name}
                                </p>
                            </h2>
                            <p className="deja-price"><DejaPrice product={{current_price: currentItem.current_price, original_price: currentItem.original_price}}/></p>
                            <ProductChoice 
                                status={`Color: ${currentItem.color}`}
                                choices={shop_items.map((item, index) => ({index: index, choice: item.color}))}
                                action={this.changeSelect}
                                active={this.state.current}
                            />
                        </div>
                        <div className="product-action-container">
                            <a className="purchase-btn" target="_blank" rel="noopener noreferrer" href={shop_url}>Shop Now</a>
                        </div>
                    </div>
                </div>
                <div className="deja-description">
                    {descriptions.filter(description => !!this.props[description]).map((description, index)=>(
                        <div className="items">
                            <h4 className="title">{descriptionsMap[description]}</h4>
                            <p className="description">{this.props[description]}</p>
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}

export default Product;


// WEBPACK FOOTER //
// ./src/features/product/productDetail/component/index.js